if (!customElements.get('model-sizes-text')) {
  class ModelSizesText extends HTMLElement {
    connectedCallback() {
      this._onGenderChange = (e) => this.updateVisibility(e.detail.gender);
      document.addEventListener('gender:change', this._onGenderChange);

      const raw = localStorage.getItem(window.genderStorageKey)?.toLowerCase();
      const gender = raw?.startsWith('women') ? 'women' : 'men';
      this.updateVisibility(gender);
    }

    disconnectedCallback() {
      document.removeEventListener('gender:change', this._onGenderChange);
    }

    updateVisibility(gender) {
      const menEl = this.querySelector('.fixed-media-content__model-size--men');
      const womenEl = this.querySelector('.fixed-media-content__model-size--women');

      const hasMen = menEl !== null;
      const hasWomen = womenEl !== null;

      if (hasMen && !hasWomen) {
        menEl.classList.add('visible');
        return;
      }

      if (hasWomen && !hasMen) {
        womenEl.classList.add('visible');
        return;
      }

      if (menEl) gender === 'men' ? menEl.classList.add('visible') : menEl.classList.remove('visible');
      if (womenEl) gender === 'women' ? womenEl.classList.add('visible') : womenEl.classList.remove('visible');
    }
  }

  customElements.define('model-sizes-text', ModelSizesText);
}
